export const pageProps = () =>
{
  return({
    px: 4
  });
};

export const pageTitleProps = () =>
{
  return({
    fontWeight: 600,
    marginTop: '5rem',
    marginBottom: '4rem',
    fontSize: {xs: '3rem', md: '3.5rem'},
    textAlign: 'center',
    color: '#FF80FF'
  });
};

export const sectionHeadingProps = () =>
{
  return({
    fontWeight: 700,
    marginTop: '2rem',
    marginBottom: '1rem',
    fontSize: {xs: '2rem', md: '2.5rem'},
    textAlign: 'left',
    color: '#FF80FF'
  });
};

export const subSectionHeadingProps = () =>
{
  return({
    fontWeight: 700,
    fontSize: {xs: '1.75rem', md: '2rem'},
    color: '#FF80FF'
  });
};

export const subSubSectionHeadingProps = () =>
{
  return({
    fontWeight: 700,
    fontSize: '1.5rem',
    color: '#FF80FF'
  });
};

export const normalParaProps = () =>
{
  return({
    fontWeight: 400,
    marginTop: '1.15rem',
    fontSize: {xs: '1rem', md: '1.25rem'},
    textAlign: 'left',
    color: '#FFDFEF'
  });
};

export const bulletParaProps = () =>
{
  return({
    fontWeight: 400,
    fontSize: {xs: '1rem', md: '1.25rem'},
    textAlign: 'left',
    color: '#FFDFEF'
  });
};

export const emphasizedText = () =>
{
  return({
    fontWeight: 400,
    fontSize: {xs: '1rem', md: '1.15rem'},
    textAlign: 'left',
    color: '#FF80FF',
    display: 'inline'
  });
};

export const decimalListProps = () =>
{
  return({
    listStyleType: 'decimal',
    pl: 2
  });
};

export const upperAlphaListProps = () =>
{
  return({
    listStyleType: 'upper-alpha',
    pl: 2
  });
};

export const lowerAlphaListProps = () =>
{
  return({
    listStyleType: 'lower-alpha',
    pl: 2
  });
};

export const lowerRomanListProps = () =>
{
  return({
    listStyleType: 'lower-roman',
    pl: 2
  });
};

export const bulletListProps = () =>
{
  return({
    listStyleType: 'square',
    pl: 2
  });
};

export const listItemProps = () =>
{
  return({
    display: 'list-item'
  });
};
